import React, {Fragment} from "react";
import ScoutingDatatable from "./ScoutingDatatable";
import {Link} from "react-router-dom";
import SVG from "react-inlinesvg";
import SA_ConfirmDelete from "../../../../../ui/sweetalert/SA_ConfirmDelete";
import "../../../../../../assets/sass/pages/scouting/delete-confirm-modal.scss";


import delete_svg from '../../../../../../assets/svg/actions/icn-delete-24px-grey.svg';
import edit_svg from '../../../../../../assets/svg/actions/icn-edit.svg';

class SavedScoutingsDatatable extends ScoutingDatatable {

    openDeleteModal = (event) => {
        event.preventDefault();
        new SA_ConfirmDelete().fire();
    }

    renderButtonsScouting = () => {
        return (
            <div className="buttons-scouting--cell">
                <Link to={'#'} onClick={this.openDeleteModal}><SVG src={delete_svg}/></Link>
                <Link to={`/my-scouting/player-evaluation`}><SVG src={edit_svg}/></Link>
            </div>
        )
    }
}

export default SavedScoutingsDatatable;
